import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";

const SEVERITIES = ["error", "warning", "info", "success"];

export default function TablePageAlerts({ items }) {
  const list = (items ?? []).filter((entry) => entry?.message);
  if (!list.length) return null;

  return (
    <Stack spacing={2} sx={{ mb: 2 }}>
      {list.map((entry, index) => (
        <Alert
          key={entry.key ?? String(index)}
          severity={SEVERITIES.includes(entry.severity) ? entry.severity : "info"}
          onClose={typeof entry.onClose === "function" ? entry.onClose : undefined}
        >
          {entry.message}
        </Alert>
      ))}
    </Stack>
  );
}

TablePageAlerts.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      severity: PropTypes.oneOf(SEVERITIES),
      message: PropTypes.node,
      onClose: PropTypes.func,
    })
  ),
};

TablePageAlerts.defaultProps = {
  items: [],
};
